import React, { useEffect, useRef } from 'react';
import './Marquee.css';

const Marquee = ({ text, imageSrc }) => {
  const div1Ref = useRef(null);
  const mainDivRef = useRef(null);

  useEffect(() => {
    if (div1Ref.current && mainDivRef.current) {
      mainDivRef.current.style.width = `${div1Ref.current.offsetWidth}px`;
    }
  }, [text, imageSrc]);

  return (
    <div id="maindiv" ref={mainDivRef}>
      <div className={text.length > 100 ? 'div1Slow' : 'div1Fast'} ref={div1Ref}>
        {text ? (
          <p>{text}</p>
        ) : (
          [...Array(4)].map((_, index) => (
            <img 
              key={index} 
              src={imageSrc} 
              alt={`logo-${index}`} 
              style={{ width: "230px", marginRight: "80px" }} 
            />
          ))
        )}
      </div>
      <div className={text.length > 100 ? 'div2Slow' : 'div2Fast'}>
        {text ? (
          <p>&nbsp;&nbsp;&nbsp;{text}</p>
        ) : (
          [...Array(4)].map((_, index) => (
            <img 
              key={index + 10} 
              src={imageSrc} 
              alt={`logo-${index}`} 
              style={{ width: "230px", marginRight: "80px" }} 
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Marquee;
